import * as styledComponents from "styled-components";

import { IThemeInterface } from "styles/theme";

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  withTheme,
  // @ts-expect-error TODO please fix this error
} = styledComponents as styledComponents.ThemedStyledComponentsModule<
  IThemeInterface
>;

export { css, createGlobalStyle, keyframes, ThemeProvider, withTheme };
export default styled;
